module.exports = __webpack_public_path__ + "img/menu_spor.27d98adc.svg";